// MediaSourceWrapper.jsx
import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { NULL_FUNCTION, EMPTY_OBJECT } from '../resource/defaults.js';
import { getBlurredAssetManifestUrl } from '../resource/getMediaAsset.js';

const MediaSourceWrapper = ({
  children = NULL_FUNCTION,
  sources = EMPTY_OBJECT,
  blurredAssetType = '',
  messageId = '',
  contentUrl = '',
  isContentUrlFetching = false,
  fetchBlurredResourceUrl = NULL_FUNCTION,
}) => {
  const resourceUrl = sources[0]?.src;
  const blurredUrl = getBlurredAssetManifestUrl({ resourceUrl });
  const isFallbackRequired = Boolean(blurredUrl);

  useEffect(() => {
    if (isFallbackRequired && !contentUrl && !isContentUrlFetching) {
      fetchBlurredResourceUrl({
        messageId,
        resourceUrl,
        blurredAssetType,
      });
    }
  }, [
    contentUrl,
    fetchBlurredResourceUrl,
    isContentUrlFetching,
    messageId,
    isFallbackRequired,
    resourceUrl,
    blurredAssetType,
  ]);

  if (!isFallbackRequired) {
    return children({ mediaSource: { contentUrl: resourceUrl } });
  }

  return contentUrl ? children({ mediaSource: { contentUrl } }) : null;
};

MediaSourceWrapper.propTypes = {
  children: PropTypes.func.isRequired,
  messageId: PropTypes.string,
  sources: PropTypes.object,
  blurredAssetType: PropTypes.string,
  contentUrl: PropTypes.string,
  isContentUrlFetching: PropTypes.bool,
  fetchBlurredResourceUrl: PropTypes.func.isRequired,
};

export default MediaSourceWrapper;
